<template>
  <v-navigation-drawer :width="creationMode ? '600' : '500'" right permanent>
    <v-layout column>
      <v-layout class="pa-3 grey--text text--darken-2" align-center>
        <v-icon left>edit</v-icon>
        <span class="toolbar-title">Editar documento</span>
      </v-layout>
      <v-layout justify-center class="tabs-container">
        <v-tabs v-model="selectedTab" color="#4185f4" dark>
          <v-tab>Obrigatórios</v-tab>
          <v-tab>Opcionais</v-tab>
          <v-tab>Automáticos</v-tab>
        </v-tabs>
      </v-layout>
      <v-layout class="mx-2 my-2 search-field-field-sidebar">
        <v-text-field flat solo round placeholder="Buscar campo" prepend-inner-icon="search" v-model="search" />
      </v-layout>
      <v-layout align-center justify-space-between class="layout my-2 px-2 py-1 align-center elevation-1">
        <span class="fields-count-label" v-if="!creationMode">Campos</span>
        <v-btn round small dark class="filled-field-pill-count" color="#0000008a">{{ activeFilledFieldsCount.length }} /
          {{ activeFields.length }}</v-btn>
        <v-btn @click.stop="openEditFieldDialog(null, 'create')" small flat color="blue"
          v-if="creationMode && selectedTab !== 2">
          <v-icon left>mdi-plus</v-icon>
          <span>Adicionar novo campo</span>
        </v-btn>
      </v-layout>
      <v-layout class="fields-container">
        <v-expansion-panel v-show="!isEmpty(activeFields)">
          <v-expansion-panel-content v-for="(field) in         activeFields        " :key="field.field_name"
            :hide-actions="creationMode">
            <template v-slot:header v-slot:activator="">
              <v-layout align-center justify-space-between>
                <div>
                  <v-icon size="16" class="mr-2">{{ fieldTypeIcon(field.type) }}</v-icon>
                  {{ field.alias }}
                </div>
                <v-layout justify-end>
                  <v-btn @click.stop="addField(field)" small flat color="blue">
                    <v-icon left>mdi-plus</v-icon>
                    <span>Adicionar</span>
                  </v-btn>
                  <v-btn @click.stop="openEditFieldDialog(field, 'edit')" icon small v-ripple="false"
                    v-if="creationMode && selectedTab !== 2">
                    <v-icon size="18">mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn @click.stop="removeField(field)" icon small v-ripple="false"
                    v-if="creationMode && selectedTab !== 2">
                    <v-icon color="red" size="18">mdi-delete</v-icon>
                  </v-btn>
                </v-layout>
              </v-layout>
            </template>
            <v-card class="grey lighten-3">
              <v-card-text class="mx-2" v-if="!creationMode">
                <v-text-field v-if="isTextFieldType(field.type)" solo :value="getFieldValue(field.field_name)"
                  @input="changeFieldValue(field.field_name, $event)" :mask="defineMask(field)"
                  :readonly="selectedTab === 2 || field.editable" />
                <div class="datepicker-container" style="position: relative">
                  <v-menu v-if="field.type === 'date'" ref="menu" v-model="menu" :close-on-content-click="false"
                    :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field solo
                        :value="!!getFieldValue(field.field_name) ? getDateFormatted(field.field_name) : ''" v-on="on"
                        no-title @input="changeFieldValue(field.field_name, $event)"
                        :readonly="selectedTab === 2 || field.editable" />
                    </template>
                    <v-date-picker ref="picker" :value="getFieldValue(field.field_name)" no-title locale="pt-br"
                      @change="changeFieldValue(field.field_name, $event); menu = false " />
                  </v-menu>
                </div>
                <v-text-field v-if=" field.type === 'currency' " v-money=" money " solo
                  :value=" getFieldValue(field.field_name) " @input=" changeFieldValue(field.field_name, $event) "
                  :readonly=" selectedTab === 2 || field.editable " />
                <v-select v-if=" field.type === 'select' || field.type === 'checkbox' " :items=" field.options "
                  :value=" getFieldValue(field.field_name) " item-text="answer" item-value="answer"
                  :menu-props=" { maxHeight: '370' } " :multiple=" field.type === 'checkbox' "
                  :chips=" field.type === 'checkbox' " label="Selecione" :clearable=" field.required === false "
                  @input=" changeFieldValue(field.field_name, $event) "
                  :readonly=" selectedTab === 2 || field.editable "></v-select>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-layout class="mt-5" v-show=" isEmpty(activeFields) " column align-center justify-center>
          <v-icon class="mb-2" size=32>mdi-message-outline</v-icon>
          <span>Não há campos disponíveis na categoria</span>
        </v-layout>
      </v-layout>
    </v-layout>
    <v-dialog v-model=" showDialogEditField " width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <h4 class="headline">Campos do Documento</h4>
        </v-card-title>

        <v-form @submit.prevent=" saveField " ref="form" v-model=" editFieldForm ">
          <v-card-text class="no-overflow">
            <v-layout>
              <v-text-field pesistent-hint label="Nome do campo (não pode conter espaços ou caracteres especiais)"
                v-model=" editingField.field_name " :disabled=" editingField.mode === 'edit' "
                :rules=" [validationRules.required, validationRules.noSpaces, validationRules.noSpecialAndNumbers] " />
            </v-layout>
            <v-layout>
              <v-text-field pesistent-hint label="Título do campo" v-model=" editingField.alias "
                :rules=" [validationRules.required] " />
              <v-spacer />
              <v-select :items=" types " v-model=" editingField.type " item-text="name" item-value="value"
                :menu-props=" { maxHeight: '370' } " label="Tipo do campo" persistent-hint
                :rules=" [validationRules.required] " :selectable=" item => item.disabled "></v-select>
            </v-layout>
            <template v-if=" editingField.type === 'select' || editingField.type === 'checkbox' ">
              <v-divider />
              <v-list v-for="        listItem         in         editingField.options        " :key=" listItem.answer ">
                <v-list-tile>
                  <v-list-tile-title>
                    {{ listItem.answer }}
                  </v-list-tile-title>
                  <v-list-tile-action>
                    <v-btn icon flat class="mr-2" @click=" removeOption(listItem.answer) ">
                      <v-icon color="grey darken-1">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
              <v-divider />
              <v-layout align-center justify-space-between>
                <v-flex xs9>
                  <v-text-field pesistent-hint label="Novo valor" v-model=" editingField.newOption " />
                </v-flex>
                <v-btn @click=" addOption() " flat>
                  <v-icon left>mdi-plus</v-icon>
                  <span>Adicionar</span>
                </v-btn>
              </v-layout>
            </template>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn type="button" flat color="black" @click=" $event => showDialogEditField = false ">Cancelar</v-btn>
            <v-btn type="submit" flat color="blue" :disabled=" !editFieldForm ">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { get, last, isEmpty, concat, flatten } from 'lodash';
import fieldTypeIcon from '@/mixins/field-type-icon';
import masks from '@/mixins/masks';
import format from 'date-fns/format';
import { VMoney } from 'v-money';
import validationRules from '@/mixins/validation-rules';
import { runInThisContext } from 'vm';

export default {
  name: 'fields-sidebar',
  directives: { money: VMoney },
  props: ['creationMode', 'html'],
  data() {
    return {
      fieldTypeIcon,
      fieldsFound: [],
      format,
      masks,
      menu: false,
      validationRules,
      editFieldForm: false,
      showDialogEditField: false,
      editingField: {
        mode: 'create',
        field_name: '',
        newOption: '',
        alias: '',
        type: '',
        options: [],
        required: false,
        editable: false,
      },
      types: [
        { name: 'Texto', value: 'text' },
        { name: 'Texto longo', value: 'textarea' },
        { name: 'HTML', value: 'html' },
        { name: 'E-mail', value: 'email' },
        { name: 'Número', value: 'number' },
        { name: 'Monetário', value: 'currency' },
        { name: 'Data', value: 'date' },
        { name: 'CPF/CNPJ', value: 'cpf_cnpj' },
        { name: 'Múltipla escolha', value: 'checkbox' },
        { name: 'Escolha única', value: 'select' },
        { name: 'Radio', value: 'radio', disabled: true },
        { name: 'Table', value: 'table', disabled: true }
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      selectedTab: 0,
      search: '',
    };
  },
  computed: {
    expand(event) {
      if (this.creationMode) {
        event.preventDefault();
      }
    },
    documentToEdit() {
      return this.$store.getters.documentToEdit;
    },
    fields() {
      if (this.creationMode) {
        return get(this.documentToEdit, 'fields', []);
      } else {
        return get(this.documentToEdit, 'document_type.fields', []);
      }
    },
    documentFields() {
      return get(this.fields, 'model_fields', []);
    },
    filledFields() {
      if (this.documentToEdit.document_versions == null) {
        return {};
      }
      return get(last(this.documentToEdit.document_versions), 'filled_fields', {});
    },
    activeFields() {
      const expression = new RegExp(this.search, 'i');
      if (this.selectedTab === 0) {
        let ff = Object.assign([], get(this.fields, 'model_fields', []));
        if (ff !== null) {
          ff = ff.filter(f => f.required && !f.editable && expression.test(f.alias));
          // retorna fields obrigatorios
          return ff;
        }
      } else if (this.selectedTab === 1) {
        let ff = Object.assign([], get(this.fields, 'model_fields', []));
        if (ff !== null) {
          ff = ff.filter(f => !f.required && !f.editable && expression.test(f.alias));
          return ff; // retorna fields opcionais
        }
      } else if (this.selectedTab === 2) {
        let ff = [];
        ff = concat(ff, get(this.fields, 'document_fields', []));
        const entity_fields = get(this.fields, 'entity_fields', []); // eslint-disable-line
        if (entity_fields != null) { // eslint-disable-line
          ff = concat(ff, entity_fields);
        }
        ff = concat(ff, get(this.fields, 'folder_fields', []));
        ff = concat(ff, get(this.fields, 'other_fields', []));
        ff = concat(ff, get(this.fields, 'requester_fields', []));
        ff = concat(ff, get(this.fields, 'transaction_fields', []));
        ff = ff.filter(f => expression.test(f.alias));
        return ff; // retorna fields automaticos
      }
      return [];
    },
    activeFilledFieldsCount() {
      return flatten(this.activeFields).filter(af => this.filledFields[af.field_name]);
    },
  },
  methods: {
    isEmpty,
    getDateFormatted(field_name) {
      const date = format(this.getFieldValue(field_name), 'DD/MM/YYYY');
      return date === 'Invalid Date' ? null : date;
    },
    addOption() {
      if (!this.editingField.newOption) {
        return this.$store.dispatch('toggleSnackbar', {
          show: true,
          timeout: 6000,
          color: 'error',
          message: 'Você precisa informar um valor!',
          messageIcon: 'mdi-check',
        });
      }
      if (this.editingField.options.find(a => a.answer === this.editingField.newOption)) {
        return this.$store.dispatch('toggleSnackbar', {
          show: true,
          timeout: 6000,
          color: 'error',
          message: 'Este valor já foi adicionado!',
          messageIcon: 'mdi-check',
        });
      }

      this.editingField.options = [...this.editingField.options, { answer: this.editingField.newOption }];
    },
    removeOption(answer) {
      this.editingField.options = this.editingField.options.filter(a => a.answer !== answer);
    },
    removeField(field) {
      console.log(this.html)
      // search for field in html
      const fieldRegex = new RegExp(`<span[^>]*?id="${field.field_name}"[^>]*?>(.*)<\/span>`, 'gm');
      if (fieldRegex.test(this.html)) {
        console.log('erro')
        return this.$store.dispatch('toggleSnackbar', {
          show: true,
          timeout: 6000,
          color: 'error',
          message: 'Este campo está sendo utilizado no documento, remova-o antes de excluí-lo!',
          messageIcon: 'mdi-check',
        });
      }

      this.documentToEdit.fields.model_fields = this.documentToEdit.fields.model_fields.filter(f => f.field_name !== field.field_name);
    },
    saveField() {
      if (this.editingField.mode === 'edit') {
        const currentField = this.documentToEdit.fields.model_fields.find(({ field_name }) => field_name === this.editingField.field_name);
        Object.assign(currentField, this.editingField);
      } else {
        const hasField = this.documentFields.find(f => f.field_name === this.editingField.field_name);
        if (hasField) {
          return this.$store.dispatch('toggleSnackbar', {
            show: true,
            timeout: 6000,
            color: 'error',
            message: 'Este campo já existe!',
            messageIcon: 'mdi-check',
          });
        }
        this.documentToEdit.fields.model_fields.push({ ...this.editingField });
      }
      this.$emit('changeDocumentFieldValue');
      this.showDialogEditField = false
    },
    openEditFieldDialog(field, mode = 'create') {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      if (mode == 'edit') {
        this.editingField = {
          ...Object.assign({}, field),
          newOption: '',
          mode: 'edit'
        };
      } else {
        this.editingField = {
          mode: 'create',
          field_name: '',
          alias: '',
          type: '',
          newOption: '',
          options: [],
          required: this.selectedTab === 0,
          editable: false,
        }
      }

      this.showDialogEditField = true;
    },
    getFieldValue(fieldName) {
      return this.filledFields[fieldName];
    },
    changeFieldName(fieldName, val) {
      this.$store.dispatch('changeDocumentFieldName', { fieldName, val });
      this.$emit('changeDocumentFieldName', { fieldName, val });
    },
    changeFieldValue(fieldName, val) {
      if (Array.isArray(val) && val.length === 0) {
        this.$store.dispatch('changeDocumentFieldValue', { fieldName, val: null });
        this.$emit('changeDocumentFieldValue', { fieldName, val: null });
      } else {
        this.$store.dispatch('changeDocumentFieldValue', { fieldName, val });
        this.$emit('changeDocumentFieldValue', { fieldName, val });
      }
    },
    addField(field) {
      this.$emit('selectField', field);
    },
    isTextFieldType(fieldType) {
      return fieldType === 'text' || fieldType === 'textarea' || fieldType === 'email' || fieldType === 'number' ||
        fieldType === 'cpf_cnpj';
    },
    defineMask(field) {
      if (field.type === 'cpf_cnpj' && this.getFieldValue(field.field_name)) {
        return this.getFieldValue(field.field_name).length <= 11 ? '###.###.###-###' : masks.cnpj;
      }
      // mask ## to date
      if (field.type === 'date' && this.getFieldValue(field.field_name)) {
        return '##/##/####';
      }

      return '';
    },
  },
  watch: {
    documentFields(val) {
      if (!isEmpty(val)) {
        this.fieldsFound = get(this.fields, 'model_fields', []);
      }
    },
  },
};
</script>

<style lang="scss">
.toolbar-title {
  font-size: 18px;
}

.tabs-container {
  background-color: #4185f4;
}

.filled-field-pill-count {
  cursor: unset;
}

.fields-count-label {
  color: #0000008a;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.fields-container {
  max-height: calc(100vh - 271px);
  overflow-y: auto;
  overflow-x: hidden;
}

.search-field-field-sidebar {
  .v-input {
    .v-input__control {
      .v-input__slot {
        background-color: rgba(0, 0, 0, 0.04);
        border-radius: 23px;
        margin: 0;
      }

      .v-text-field__details {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/document/editor/FieldsSidebar.vue